export default __webpack_public_path__ + "static/media/Question.43680736.svg";